// extracted by mini-css-extract-plugin
module.exports = {"element":"copyBlock_element__2AQkw","heading":"copyBlock_heading__2Gvp4"};